var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareHatching = function SvgSquareHatching(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2.071,
    clipPath: "url(#square-hatching_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.386-351.061-774.107 747.546M406.788-354.786-367.318 392.76M403.191-358.511l-774.107 747.545M399.594-362.237l-774.107 747.546M395.996-365.962l-774.107 747.546M392.398-369.687l-774.106 747.546M388.801-373.413l-774.106 747.546"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "square-hatching_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgSquareHatching;